import { render, staticRenderFns } from "./ThirdPage.vue?vue&type=template&id=9f0372a0&scoped=true"
import script from "./ThirdPage.vue?vue&type=script&lang=js"
export * from "./ThirdPage.vue?vue&type=script&lang=js"
import style0 from "./ThirdPage.vue?vue&type=style&index=0&id=9f0372a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0372a0",
  null
  
)

export default component.exports